"use client";

import type * as React from "react";

import { AppInsetBody } from "@/components/app-main-width";
import { AuthGate } from "@/components/auth-gate";
import { CAPACITY_BANNER_OFFSET, CapacityNoticeBanner } from "@/components/capacity-notice-banner";
import { AppSidebar } from "@/components/sidebar.app";
import { SiteHeader } from "@/components/site-header";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { useAuth } from "@/lib/auth";

export const AppShell = ({ children }: { children: React.ReactNode }) => {
  const { capacityStatus } = useAuth();
  const showCapacityNotice = capacityStatus != null && capacityStatus.state !== "granted";

  return (
    <AuthGate>
      <SidebarProvider
        className="flex min-h-svh w-full flex-col"
        style={
          {
            "--sidebar-width": "calc(var(--spacing) * 72)",
            "--header-height": "calc(var(--spacing) * 12)",
            "--capacity-banner-offset": showCapacityNotice ? CAPACITY_BANNER_OFFSET : "0px",
          } as React.CSSProperties
        }
      >
        <CapacityNoticeBanner variant="global" />
        <div className="flex min-h-0 min-w-0 flex-1 flex-row">
          <AppSidebar variant="sidebar" />
          <SidebarInset>
            <SiteHeader />
            <AppInsetBody className="flex flex-1 flex-col">{children}</AppInsetBody>
          </SidebarInset>
        </div>
      </SidebarProvider>
    </AuthGate>
  );
};
